import { render, staticRenderFns } from "./MessagePool.vue?vue&type=template&id=b0b45382&"
import script from "./MessagePool.vue?vue&type=script&lang=babel&"
export * from "./MessagePool.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports